import { render, staticRenderFns } from "./AdminModify.vue?vue&type=template&id=6cf74910&"
import script from "./AdminModify.vue?vue&type=script&lang=ts&"
export * from "./AdminModify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports